import { render, staticRenderFns } from "./CampaignReport_v2.vue?vue&type=template&id=31c1851a&"
import script from "./CampaignReport_v2.vue?vue&type=script&lang=js&"
export * from "./CampaignReport_v2.vue?vue&type=script&lang=js&"
import style0 from "./CampaignReport_v2.vue?vue&type=style&index=0&id=31c1851a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports